module.exports = __webpack_public_path__ + "static/media/user_name.dcbdff57.svg";